import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const WarningIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      viewBox="0 2 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7319 4C12.9621 2.66667 11.0376 2.66667 10.2678 4L2.47357 17.5C1.70377 18.8333 2.66602 20.5 4.20562 20.5H19.7941C21.3337 20.5 22.2959 18.8333 21.5261 17.5L13.7319 4ZM11.9994 7.80078C12.4716 7.80078 12.8544 8.18357 12.8544 8.65578L12.8544 13.6973C12.8544 14.1695 12.4716 14.5523 11.9994 14.5523C11.5272 14.5523 11.1444 14.1695 11.1444 13.6973L11.1444 8.65578C11.1444 8.18358 11.5272 7.80078 11.9994 7.80078ZM11.9998 15.6772C12.472 15.6774 12.8547 16.0603 12.8546 16.5325L12.8545 16.9372C12.8543 17.4094 12.4714 17.7921 11.9992 17.792C11.527 17.7918 11.1443 17.4089 11.1445 16.9367L11.1446 16.532C11.1447 16.0598 11.5276 15.6771 11.9998 15.6772Z"
        fill={strokeColor}
      />
    </svg>
  );
};
